<template>

    <div class="brt-swipe" ref="brtSwipe">
        <div class='brt-swipe-wrap'>
            <slot></slot>
        </div>
        <slot name="pagination"></slot>
    </div>

</template>

<script>

    import Swiper from './swiper.js'

    export default {
        name: "Swipe",
        props: {
            options: {
                type: Object
            }
        },

        provide () {
            return { Swipe : this };
        },

        data() {
            return {
                swipe: null
            }
        },

        beforeDestroy() {
            this.swipe.kill();
        },

        mounted() {
            this.swipe = new Swiper(this.$refs.brtSwipe, this.options);
        }
    }
</script>

<style lang="less">

    @import "../../styles/comm.less";

    .brt-swipe,
    .brt-swipe-wrap {
        overflow: hidden;
        position: relative;
    }

</style>
